<template>
  <div class="page_eleApplication">
    <div class="eleTltle">小杰闪查</div>
    <div class="eleForm" v-loading="isLoading">
      <van-form @submit="onSubmit">
        <van-field v-model="form.name" required label="姓名" :rules="[{ required: true, message: '请填写姓名' }]" />
        <van-field v-model="form.tel" required label="手机号" :rules="[{ required: true, message: '请填写手机号' }]" />

        <input id="upload_file" type="file" style="display: none;" accept='image/*' name="file"
          @change="fileChange($event)" />
        <van-field v-model="form.idcard" required v-if="hasIdCard" label="身份证号码" right-icon="photograph"
          right-icon-class="photo_o" @click-right-icon="distinguish('#upload_file')"
          :rules="[{ required: true, message: '请填写身份证号码' }]" />
        <!-- <van-field v-model="form.idcard" required v-if="hasIdCard" label="身份证号码" :rules="[{ required: true, message: '请填写身份证号码' }]" /> -->

        <input id="upload_file2" type="file" style="display: none;" accept='image/*' name="file"
          @change="fileChange2($event)" />
        <van-field v-model="form.Bankcard" required v-if="hasBankCard" label="银行卡号" right-icon="photograph"
          right-icon-class="photo_o" @click-right-icon="distinguish('#upload_file2')"
          :rules="[{ required: true, message: '请填写银行卡号' }]" />
        <!-- <van-field v-model="form.Bankcard" required v-if="hasBankCard" label="银行卡号" :rules="[{ required: true, message: '请填写银行卡号' }]" /> -->

        <van-field v-model="form.Entname" required v-if="hasEntname" label="企业名称"
          :rules="[{ required: true, message: '请填写身企业名称' }]" />
        <van-field v-model="form.Entcode" required v-if="hasEntcode" label="统一社会信用代码"
          :rules="[{ required: true, message: '请填写统一社会信用代码' }]" />
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit" :disabled="isSuccess || !id || isLapse">{{ isLapse ?
            '二维码已失效' : isSuccess ? '已提交' : '提交' }}</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import xz from "@/common";
export default {
  data() {
    return {
      form: {
        name: '',
        idcard: '',
        tel: '',
        Bankcard: '',
        BusiType: '',
        BusiId: '',
        productid: [],
        Entcode: '',
        Entname: '',
        Id: '',
        BusiId: '', //1外部 2内部
      },
      isLoading: false,
      isSuccess: false,
      isLapse: false,
      hasIdCard: false,
      hasName: false,
      hasTel: false,
      hasBankCard: false,
      hasEntcode: false,
      hasEntname: false,
    };
  },
  async created() {
    this.$store.commit("setHiddenLeft", true);
    console.log(this.$route);
    if (this.$route.query.id != undefined && this.$route.query.id) {
      this.id = this.$route.query.id;
      this.form.Id = this.$route.query.id;
      let data = {
        Id: this.id
      }
      xz.QueryCert(JSON.stringify(data)).then(res => {
        if (res.status == 'ok') {
          this.form.BusiId = res.data.BusiId;
          this.form.BusiType = res.data.BusiType;
          this.form.productid = res.data.productid;
          this.form.BusiId = res.data.BusiId;
          if (!this.isNull(res.data.hasIdCard)) {
            this.hasIdCard = res.data.hasIdCard;
          }
          if (!this.isNull(res.data.hasName)) {
            this.hasName = res.data.hasName;
          }
          if (!this.isNull(res.data.hasTel)) {
            this.hasTel = res.data.hasTel;
          }
          if (!this.isNull(res.data.hasBankCard)) {
            this.hasBankCard = res.data.hasBankCard;
          }
          if (!this.isNull(res.data.hasEntcode)) {
            this.hasEntcode = res.data.hasEntcode;
          }
          if (!this.isNull(res.data.hasEntname)) {
            this.hasEntname = res.data.hasEntname;
          }
        } else {
          this.isLapse = true;
        }
      })
    } else {
      this.$toast({
        duration: 4000,
        type: "fail",
        message: "扫码异常,或者二维码已失效，请联系客服重新获取",
      });
    }
  },
  methods: {
    //调用相册&相机识别
    distinguish(name) {
      $(name).click();
    },
    fileChange(el) {
      let file = $("#upload_file").get(0).files[0];
      let maxSize = 1024 * 1024 * 3;
      if (file.size <= maxSize) {
        this.uploadImg(file);
      } else {
        xz.imgCompress(file).then((f) => {
          if (f) {
            this.uploadImg(f)
          }
        });
      }

    },
    uploadImg(file) {
      const formData = new FormData();
      formData.append("type", 0);
      formData.append("pagename", 'Image');
      formData.append("file", file);
      console.log("formData", formData, file.size);
      xz.distinguishImg(formData).then((res) => {
        if (res.data.idCard != undefined) {
          this.$toast.success('识别成功，请核对');
          this.form.idcard = res.data.idCard;
          this.form.name = res.data.name;
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    fileChange2() {
      let file = $("#upload_file2").get(0).files[0];
      let maxSize = 1024 * 1024 * 3;
      if (file.size <= maxSize) {
        this.uploadImg2(file);
      } else {
        xz.imgCompress(file).then((f) => {
          if (f) {
            this.uploadImg2(f)
          }
        });
      }
    },
    uploadImg2(file) {
      const formData = new FormData();
      formData.append("type", 1);
      formData.append("pagename", 'Image');
      formData.append("file", file);
      console.log("formData", formData);
      xz.distinguishImg(formData).then((res) => {
        if (res.data.no != undefined) {
          this.form.Bankcard = res.data.no;
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    getImgInfo() {
      xz.distinguishImg();
    },
    onSubmit() {
      if (this.form.tel.length != 11) {
        this.$toast.fail('请输入正确的手机号码');
      } else if (this.form.idcard.length != 18) {
        this.$toast.fail('请输入正确的身份证号码');
      } else {
        if (!this.isLoading) {
          this.isLoading = true;
          xz.QueryCertReport(JSON.stringify(this.form)).then((res) => {
            if (res.status == "ok") {
              this.isLoading = false;
              this.$toast({
                duration: 4000,
                type: "success",
                message: "保存成功,请查收授权短信",
              });
              this.isSuccess = true;
            } else {
              setTimeout(() => {
                this.isLoading = false;
              }, 2000);
              this.$toast.fail(res.msg);
            }
          });
        }
      }

    },
    isNull(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == "NaN" ||
        o == '[{}]'
      );
    },
  },
};
</script>
<style scoped>
.page_eleApplication {
  background: #fff;
  min-height: 100vh;
}

.eleTltle {
  font-weight: 600;
  font-size: 17px;
  text-transform: capitalize;
  width: 100%;
  height: 56px;
  line-height: 56px;
  background: #fff;
  text-align: center;
}

.eleForm {
  /* background: #fff; */
  padding: 20px 0;
}
</style>
<style>
.page_eleApplication .van-icon-photograph:before {
  font-size: 26px;
}
</style>